import React from 'react';
import { motion } from 'framer-motion';
export function AuthoritySection() {
  return <section className="bg-white py-20 md:py-28 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <h2 className="text-3xl md:text-5xl text-navy mb-12 text-center" data-id="element-3">
          La Historia Detrás del Blueprint
        </h2>

        <div className="flex flex-col md:flex-row gap-12 items-center" data-id="element-4">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="w-full md:w-1/2" data-id="element-5">
            <img src="https://images.unsplash.com/photo-1511895426328-dc8714191300?auto=format&fit=crop&q=80&w=800" alt="Familia latina feliz y unida, padre con su esposa e hijos" className="rounded-2xl shadow-xl w-full object-cover aspect-square md:aspect-[4/5]" data-id="element-6" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full md:w-1/2 space-y-6 text-lg text-charcoal leading-relaxed" data-id="element-7">
            <p data-id="element-8">
              Como latino en EE.UU., viví en carne propia la frustración de
              trabajar 65 horas a la semana sin avanzar. Oraba cada noche por
              una salida, pero no tenía un sistema. El día que entendí que Dios
              no solo quería bendecirme, sino hacerme un buen administrador,
              todo cambió.
            </p>
            <p data-id="element-9">
              Diseñé "Emprender con Unción" para que ningún otro hermano latino
              tenga que aprender estas lecciones de la manera difícil. Este es
              el manual que yo hubiera querido tener cuando empecé.
            </p>
            <p className="font-bold text-navy text-xl pt-4 border-t border-gray-200" data-id="element-10">
              Mi misión es simple: que tu negocio sea el canal de bendición más
              poderoso de tu familia y tu comunidad.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}